module.exports = __webpack_public_path__ + "img/16581292_L.850be6cd.png";